<template>
    <div class="k-qrcode">
        <canvas ref="qrcode"></canvas>
    </div>
</template>

<script>
import QRCode from "qrcode";

export default {
    name: "QRCodeGenerator",
    props: {
        value: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    mounted() {
        this.generateQRCode();
    },
    watch: {
        value() {
            this.generateQRCode();
        },
    },
    methods: {
        generateQRCode() {
            QRCode.toCanvas(this.$refs.qrcode, this.value, this.options, function (error) {
                if (error) console.error(error);
            });
        },
    },
};
</script>
